import { render, staticRenderFns } from "./CreateAndShow.vue?vue&type=template&id=adb0e0bc&scoped=true&"
import script from "./CreateAndShow.vue?vue&type=script&lang=js&"
export * from "./CreateAndShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb0e0bc",
  null
  
)

export default component.exports